<template>
	<dms-edit-layout v-bind="layoutProps">
		<dms-row :gutter="20">
				<dms-card row>
					<dms-col :md="6" :sm="12" :xs="24">
					<dms-input-number :value.sync="PokladnaId" disabled label-key="POKLADNA_ID" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
					<dms-select :select-list="dropdownList.MenaId" :value.sync="MenaId" :disabled="!isCreateMode" label-key="MENA_ID" />
					</dms-col>
					<dms-col v-show="showKonvPokl" :md="6" :sm="12" :xs="24">
					<dms-select :select-list="dropdownList.PokladnakonvId" :value.sync="PokladnakonvId" label-key="POKLADNAKONV_ID" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
					<dms-input :value.sync="Text" label-key="TEXT" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
					<dms-select :select-list="dropdownList.ProvozovnaId" :value="ProvozovnaId" label-key="PROVOZOVNA_ID" @update:value="ProvozovnaUpdate" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
					<nakladove-stredisko-select :value.sync="StrednaklOzn" :text.sync="StrednaklOznText" :mutation-name="mutationsMappers.nakladoveStredisko"
						:filter="naklStredFilter"/>
						</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
					<dms-check :value.sync="HotoveQueuePrp" label-key="HOTOVE_QUEUE_PRP" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
					<dms-check :value.sync="KartouQueuePrp" label-key="KARTOU_QUEUE_PRP" />
					</dms-col>
				</dms-card>
		</dms-row>
	</dms-edit-layout>
</template>

<script>
import { editFactory } from '@/main/pages';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				nakladoveStredisko: `${this.storeUri}/${editMutations.POKLADNA_NAKLADOVE_STEDISKO_SELECT_MAPPER}`,
			};
		},
		showKonvPokl() {
			return this.PrimarniMenaId !== this.MenaId;
		},
		naklStredFilter() {
			return {
				ProvozovnaId: this.ProvozovnaId,
				VyrazenPrp: false,
			};
		},
	},

	methods: {
		ProvozovnaUpdate(value) {
			this.ProvozovnaId = value;
			this.StrednaklOzn = '';
			this.StrednaklOznText = null;
		},
	},
});
</script>
